import ReactOnRails from 'react-on-rails';

import App from './components/App/index';
import BaseUIButton from './components/Button/index';
import Clipper from './components/Clipper';
import CustomToaster from './components/CustomToaster/index';
import EmailConfirmation from './components/EmailConfirmation/index';
import EnableProfileModal from './components/EnableProfileModal/index';
import EventFollowBanner from './components/Events/EventFollowBanner/index';
import PastEventsList from './components/Events/PastEventsList/index';
import FollowButtonWithQueryClientWrapper from './components/FollowButton/FollowButtonWithQueryClientWrapper';
import LinkCopy from './components/LinkCopy/index';
import LockedLeadCaptureFormMarketingLeadCaptureWithGoogle from './components/LockedLeadCaptureForm/MarketingLeadCaptureWithGoogle';
import LockedLeadCaptureForm from './components/LockedLeadCaptureForm/index';
import MarketingModal from './components/MarketingModal/index';
import MessageUserButton from './components/MessageUserButton/index';
import Nav from './components/Nav/index';
import NewsletterFeedBanner from './components/Newsletter/NewsletterFeedBanner/index';
import OnboardingModal from './components/OnboardingModal/index';
import ProExclusiveLogo from './components/ProExclusiveLogo/index';
import ShareNav from './components/ShareNav/index';
import SocialLinks from './components/SocialLinks/index';
import SubscriptionTeam from './components/Subscription/Team/index';
import TIHeader from './components/TIHeader';
import Team from './components/Team';
import TopicDescription from './components/Topic/TopicDescription/index';
import TopicFollowAndTagModal from './components/Topic/TopicFollowAndTagModal/index';
import CorporateLanding from './components/pages/CorporateLanding/index';
import CryptoPowerlist from './components/pages/CryptoPowerlist/index';
import EnterprisePowerlistHeader from './components/pages/EnterprisePowerlist/EnterprisePowerlistHeader';
import EnterprisePowerlist from './components/pages/EnterprisePowerlist/index';
import EventInfo from './components/pages/EventInfo';
import TopicForumPosts from './components/pages/Forum/TopicForumPosts/index';
import Gift from './components/pages/Gift/index';
import HorizontalSubscribe from './components/pages/HorizontalSubscribe/index';
import OrgSignUp from './components/pages/OrgSignUp/index';
import FeaturedPartnerContainer from './components/pages/Partners/FeaturedPartnerContainer';
import SubscriberCouncilContainer from './components/pages/Partners/SubscriberCouncilContainer';
import ProMarketingCTAs from './components/pages/Pro/ProMarketingCTAs';
import ReadUsFirst from './components/pages/ReadUsFirst/index';
import ReferralLanding from './components/pages/Referral/Landing/index';
import ReferralSubscription from './components/pages/Referral/Subscription/index';
import SearchPage from './components/pages/SearchPage/index';
import SettingsUserProfile from './components/pages/Settings/UserProfile/index';
import Subscribe from './components/pages/Subscribe/index';
import SubscriptionLanding from './components/pages/SubscriptionLanding/index';

ReactOnRails.register({
  App,
  BaseUIButton,
  CustomToaster,
  LinkCopy,
  ReadUsFirst,
  Clipper,
  CorporateLanding,
  SubscriberCouncilContainer,
  CryptoPowerlist,
  EmailConfirmation,
  EnableProfileModal,
  EnterprisePowerlist,
  EnterprisePowerlistHeader,
  EventInfo,
  EventFollowBanner,
  FeaturedPartnerContainer,
  FollowButtonWithQueryClientWrapper,
  Gift,
  LockedLeadCaptureForm,
  LockedLeadCaptureFormMarketingLeadCaptureWithGoogle,
  MarketingModal,
  MessageUserButton,
  Nav,
  NewsletterFeedBanner,
  HorizontalSubscribe,
  OnboardingModal,
  OrgSignUp,
  PastEventsList,
  ProExclusiveLogo,
  ProMarketingCTAs,
  ReferralLanding,
  ReferralSubscription,
  SearchPage,
  SettingsUserProfile,
  ShareNav,
  SocialLinks,
  Subscribe,
  SubscriptionTeam,
  SubscriptionLanding,
  Team,
  TIHeader,
  TopicDescription,
  TopicFollowAndTagModal,
  TopicForumPosts,
});
